import { render, staticRenderFns } from "./faqs-card.vue?vue&type=template&id=debedc20"
import script from "./faqs-card.vue?vue&type=script&lang=js"
export * from "./faqs-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports